import React, { ErrorInfo } from "react";
import ErrorScreen from "./route/error";
import logging from "./util/logging";
import { ErrorType } from "./api/http/types";

const log = logging("global error boundry");

interface PropType {
  children?: React.ReactNode;
}

export interface ErrorTSType {
  type: ErrorType;
  timestamp?: Date;
  id?: string;
  code?: string;
}

interface StateType {
  error?: ErrorTSType;
}

export default class GlobalErrorBoundary extends React.Component<
  PropType,
  StateType
> {
  public static getDerivedStateFromError(error: ErrorTSType): StateType {
    return { error };
  }

  constructor(props: unknown) {
    super(props);
    this.state = {};
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    log.error(
      `Error: ${JSON.stringify(error)} with info: ${JSON.stringify(errorInfo)}`,
    );
  }

  public render(): React.JSX.Element {
    if (this.state.error) {
      return <ErrorScreen />;
    }
    return <>{this.props.children}</>;
  }
}
